import { Text } from "@ui-kitten/components";
import { useAppSelector } from "hooks/useAppSelector";
import React from "react";
import { Pressable, StyleSheet } from "react-native";

interface ChipProps {
  selected?: boolean;
  onPress?: () => void;
  size?: "small" | "medium" | "large";
  children: React.ReactNode;
}

const Chip: React.FC<ChipProps> = ({
  children,
  selected,
  onPress,
  size = "small",
}) => {
  const themeColor = useAppSelector((state) => state.tenant.tenantThemeColor);
  const isDark = useAppSelector((state) => state.theme.theme === "dark");

  const getBackgroundColor = () => {
    if (isDark) {
      if (selected) {
        return "rgb(235, 235, 235)";
      } else {
        return "transparent";
      }
    } else {
      if (selected) {
        return "rgb(235, 235, 235)";
      } else {
        return "white";
      }
    }
  };

  const getColor = () => {
    if (isDark) {
      if (selected) {
        return "black";
      } else {
        return "white";
      }
    }
    return themeColor; // use theme color for light theme
  };

  const getBorderColor = () => {
    if (isDark) {
      return "white";
    } else {
      return "rgba(0,0,0,0.12)";
    }
  };

  const getPadding = () => {
    const paddingMap = {
      small: 3,
      medium: 4,
      large: 6,
    };
    return paddingMap[size];
  };

  const getMinWidth = () => {
    const minWidthMap = {
      small: 38,
      medium: 50,
      large: 60,
    };
    return minWidthMap[size];
  };

  return (
    <Pressable
      onPress={onPress}
      style={[
        styles.container,
        {
          borderColor: getBorderColor(),
          backgroundColor: getBackgroundColor(),
          padding: getPadding(),
          minWidth: getMinWidth(),
        },
      ]}
    >
      <Text style={{ color: getColor() }}>{children as string}</Text>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  container: {
    borderWidth: 2,
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "flex-start",
    borderRadius: 50,
  },
});
export default Chip;
